import "./CategoryBanner.scss"

import pageTextConfig from "../../../../assets/configs/Categories Page/textConfig"
import bannerVideo from "../../../../assets/images/category_page/bannerVideo.mp4"

const CategoryBanner = () => {

  const { heading1, heading2, para } = pageTextConfig.Banner

  return (
    <section className='catPageBanner'>
      <div className="bannerVideoWrapper">
        <video playsInline autoPlay muted loop id="bannerVideo">
          <source src={bannerVideo} type="video/mp4" />
        </video>
        <div className="bannerVideoScreen">
          <div className="bannerVideoContent">
            <h1>{ heading1 }</h1>
            <h1>{ heading2 }</h1>
            <p>{ para }</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CategoryBanner